/**
 * Helper class to make the handling fetch and error more concise.
 * Todo, i need to decide if this naming is nice
 */
export class Fetchable {
	fetching = $state(false);
	error = $state<any>();
	fetch<R>(fn: () => Promise<R>): Promise<R> {
		return wrapAsyncCall(
			fn,
			(f) => (this.fetching = f),
			(e) => (this.error = this.processError(e))
		);
	}

	private processError = (e: any) => e;

	constructor(options?: { processError?: (e: any) => any; initiallyFetching?: boolean }) {
		this.processError = options?.processError || this.processError;
		this.fetching = options?.initiallyFetching || this.fetching;
	}
}

/**
 * Wraps an async call and allows to set fetching and error as we need this very often
 * @param fn function to handle
 * @param onFetching called if fetching state changes
 * @param onError called if error was handled
 */
export async function wrapAsyncCall<R>(
	fn: () => Promise<R>,
	onFetching: (f: boolean) => {},
	onError: (e: any) => {}
): Promise<R> {
	onFetching(true);
	onError(null);
	try {
		return await fn();
	} catch (e) {
		if (e instanceof Error) (e as any).__sentryHandled = true;
		onError(e);
	} finally {
		onFetching(false);
	}
}
